import { useState } from "react";

interface HeaderProps {
  search: string;
  onSearchChange: (v: string) => void;
  onSearchSubmit: () => void;
}

const navLinks = [
  { id: "home", label: "首页" },
  { id: "hotlist", label: "今日热榜" },
  { id: "category", label: "分类找瓜" },
  { id: "focus", label: "焦点瓜料" },
  { id: "stream", label: "视频速递" },
  { id: "faq", label: "答疑" },
];

export default function Header({ search, onSearchChange, onSearchSubmit }: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#home" className="group flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-mini-fill text-xl leading-none"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
              吃瓜视频
            </span>
            <span className="mt-1 hidden text-[11px] tracking-wide text-foreground-600 sm:block">
              娱乐八卦 · 速递
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form
            className="flex items-center overflow-hidden rounded-full border border-secondary-300 bg-background-100 focus-within:border-primary-400"
            onSubmit={(e) => {
              e.preventDefault();
              onSearchSubmit();
            }}
          >
            <i className="ri-search-line ml-3 text-sm text-foreground-500"></i>
            <input
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              type="text"
              placeholder="搜你想看的瓜…"
              className="w-40 bg-transparent px-2 py-2 text-sm outline-none placeholder:text-foreground-500"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="flex h-8 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-arrow-right-line text-sm"></i>
              </button>
          </form>
        </div>

        <button
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="打开菜单"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-300 text-foreground-800 lg:hidden"
        >
          <i className={`text-lg ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="flex flex-wrap gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-secondary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}